<ion-content>
  <div class="constrained-content">
    <div class="flex-space-between flexed-align-center" style="padding: 20px 20px 0">
      <ion-button
        (click)="openCreateSurveyModal()"
        *ngIf="!authService.selectedProject || authService.isProjectOwner(authService.selectedProject.id)"
      >
        New survey
      </ion-button>
      <ion-button
        fill="clear"
        class="btn-small hidden-sm"
        href="https://docs.unthread.io/engagement/surveys"
        target="_blank"
      >
        <ion-icon name="book-outline" class="padded-icon"></ion-icon>
        Learn more about surveys
      </ion-button>
    </div>
    <ion-grid>
      <ion-row>
        <ion-col size="12" *ngFor="let survey of surveys">
          <ion-card class="outline-card">
            <ion-row>
              <ion-col size="12" size-md="3" style="background: var(--ion-color-step-50)">
                <ion-card-content>
                  <ion-badge color="dark">{{ survey.type.toUpperCase() }}</ion-badge>
                  <div
                    class="flexed-align-center"
                    style="height: 68px; overflow: hidden; justify-content: space-between"
                  >
                    <ion-label
                      *ngFor="let label of getSurveyLabels(survey)"
                      [ngClass]="{ 'nps-font': survey.type === 'nps', 'csat-font': survey.type === 'csat' }"
                    >
                      {{ label }}
                    </ion-label>
                  </div>
                </ion-card-content>
              </ion-col>
              <ion-col size="12" size-md="9">
                <ion-card-header style="padding: 20px">
                  <ion-card-title>
                    <a (click)="openEditSurveyModal(survey)" class="row-link">
                      {{ survey.name }}
                    </a>
                  </ion-card-title>
                  <ion-card-subtitle style="line-height: 1.5" *ngIf="survey.description">
                    {{ survey.description }}
                  </ion-card-subtitle>
                  <ion-card-subtitle *ngIf="!authService.selectedProject">
                    Project: {{ survey.project?.name || 'All projects' }}
                  </ion-card-subtitle>
                </ion-card-header>
                <ion-card-content>
                  <ion-button
                    color="dark"
                    fill="clear"
                    class="btn-small button-dark-border"
                    (click)="openEditSurveyModal(survey)"
                  >
                    <ion-icon name="create" class="padded-icon"></ion-icon>
                    Edit
                  </ion-button>
                  <ion-button color="dark" fill="clear" class="btn-small button-dark-border" (click)="send(survey)">
                    <ion-icon name="send" class="padded-icon"></ion-icon>
                    Send
                  </ion-button>
                  <ion-button
                    color="dark"
                    fill="clear"
                    class="btn-small button-dark-border"
                    (click)="viewAnalytics(survey)"
                  >
                    <ion-icon name="stats-chart" class="padded-icon"></ion-icon>
                    Analytics
                  </ion-button>
                </ion-card-content>
              </ion-col>
            </ion-row>
          </ion-card>
        </ion-col>
        <ion-col *ngIf="!isLoading && !surveys.length">
          <ion-card class="outline-card empty-state-container" style="height: 80vh">
            <span class="placeholder-emoji">
              <ion-icon name="pie-chart-outline"></ion-icon>
            </span>
            <h1 class="placeholder-title">No surveys yet</h1>
            <p>Create your own survey to collect CSAT and NPS scores</p>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<ion-modal [isOpen]="isAnalyticsModalOpen" (willDismiss)="onDismissAnalyicsModal()" class="modal-large">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <div class="modal-title">
          <h3>Analytics</h3>
        </div>
        <ion-buttons slot="end">
          <ion-button fill="clear" class="close-button" (click)="openHelpdeskArticle()">
            <ion-icon name="book-outline" class="padded-icon"></ion-icon>
            Learn how scores are calculated
          </ion-button>
          <ion-button fill="clear" class="close-button" (click)="onDismissAnalyicsModal()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-grid>
        <app-survey-analytics [surveyId]="currentSurveyId"></app-survey-analytics>
      </ion-grid>
    </ion-content>
  </ng-template>
</ion-modal>
